import styled from "styled-components";

interface ChatbotIframeProps {
  device: string;
}

export const ChatbotIcon = styled.img`
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  cursor: pointer;
`;

export const ChatbotIframe = styled.iframe<ChatbotIframeProps>`
  height: ${(props) => (props.device == "lg" ? "554px" : "85vh")};
  width: ${(props) => (props.device == "lg" ? "360px" : "100%")};
  bottom: ${(props) => (props.device == "lg" ? "25px" : "0")};
  right: ${(props) => (props.device == "lg" ? "20px" : "0")};
  position: fixed;
  z-index: 1001;
  box-shadow: none;
`;
